import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MasterHomeCreateProfileService } from '../../service/master-home-create-profile.service';
import { compare } from '@app/features/utils/compare-string';


@Component({
  selector: 'table-associate-profile-user',
  templateUrl: './table-associate-profile-user.component.html',
  styleUrls: ['./table-associate-profile-user.component.scss'],
})
export class TableAssociateProfileUser implements OnInit {
  constructor(
    private serviceHomeCreateProfile: MasterHomeCreateProfileService,
  ) { }
  dataTableInfo: any;
  allChecked: boolean = false;
  dataTableFilter: any;
  filterAutoComplete: any;
  usersSorted = false;

  @ViewChild('sort', { static: false }) sort: MatSort;
  @Input() dataTable: Array<any>;
  @Input() dataRetrieveNode: string;
  @Output() rolesSelected: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.getDataTable();
    if (this.dataTableInfo) {

      this.dataTableInfo.sort = this.sort;
    }
  }

  ngAfterViewInit() {
    if (this.dataTableInfo) {
      this.dataTableInfo.sort = this.sort;
    }
  }


  getDataTable() {
    this.dataTable.forEach(data => {
      if (!data.checked) {
        return (data.checked = false);
      }
    });
    //let dataTable = this.dataTableInfo;
    let dataTable = this.dataTable
    dataTable?.sort((a, b) => {
      if (a.name === null) {
        a.name = '';
      }
      if (b.name === null) {
        b.name = '';
      }
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase()) ? 1 : -1;
    })
    this.dataTableInfo = new MatTableDataSource(dataTable);

    this.dataTableInfo.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      if (data.login === null || data.login === undefined) {
        data.login = '';
      }
      return (
        data.name.toLowerCase().includes(filter.toLowerCase()) ||
        data.login.toLowerCase().includes(filter.toLowerCase())
      );
    };

    this.dataTableInfo.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].naturalSort();
    this.dataTableInfo.sort = this.sort;
    this.isAllSelected();
  }

  filterDataTableInput(event) {
    this.dataTableFilter = (event.target as HTMLInputElement).value;
    this.dataTableInfo.filter = this.dataTableFilter;

    if (
      this.dataTableFilter.length > 0 &&
      this.dataTableFilter.length % 2 == 0
    ) {
      this.filterAutoComplete = this.dataTableInfo.filteredData;
    } else if (this.dataTableFilter.length == 0) {
      this.filterAutoComplete = [];
    }
  }

  toogleAllSelected() {
    this.allChecked = !this.allChecked;
    this.dataTableInfo.data.forEach(row => (row.checked = this.allChecked));
    this.onSelectRole();
  }

  isAllSelected() {
    this.allChecked = this.dataTableInfo.data.every(row => row.checked == true);
    this.onSelectRole();
  }

  toggleSelection(row) {
    this.dataTableInfo.data.forEach(data => {
      if (row.id === data.id) {
        row.checked = !row.checked;
      }
    });
    this.isAllSelected();
    this.onSelectRole();
  }

  someComplete() {
    return this.dataTableInfo?.data.some(ele => ele.checked == true);
  }

  onSelectRole() {
    this.serviceHomeCreateProfile.setRoles(
      this.dataTableInfo.data,
      this.dataRetrieveNode,
    );
    this.rolesSelected.emit(this.dataTableInfo.data);
  }

  sortData(param) {
    this.usersSorted = true;

    this.dataTableInfo.data = this.dataTableInfo?.data.sort((a, b) => {

      switch (param) {
        case 'name': return compare(a.name.naturalNormalize(), b.name.naturalNormalize(), this.usersSorted);
        case 'login': return compare(a.login.naturalNormalize(), b.login.naturalNormalize(), this.usersSorted);
        case 'profile': return compare(a.profile.name.naturalNormalize(), b.profile.name.naturalNormalize(), this.usersSorted);
        case 'status': return compare(a.status.naturalNormalize(), b.status.naturalNormalize(), this.usersSorted);
        default: return 0;
      }
    })
  }

  compare(a, b, isAsc) {
    if (a === null) {
      a = '';
    }

    if (b === null) {
      b = '';
    }

    return (a.toLowerCase() > b.toLowerCase() ? 1 : -1) * (isAsc ? 1 : -1);
  }

}
